var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.082 179.776L366.858 49H395.282L389.142 55L248.204 195.938L387 381H292L193.918 250.224L63.1422 381H34.6632L40.8578 375L181.796 234.062L43 49H138L236.082 179.776ZM83 69L302 361H347L128 69H83Z",
    fill: "#3A3347"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292 381L193.918 250.224L63.1422 381H34.6632L40.8578 375L181.796 234.062L43 49H90.5L105.5 69H83L302 361H324.5L339.5 381H292Z",
    fill: "#3A3347"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.082 179.776L366.858 49H395.282L389.142 55L248.204 195.938L387 381H292L193.918 250.224L63.1422 381H34.6632L40.8578 375L181.796 234.062L43 49H138L236.082 179.776ZM83 69L302 361H347L128 69H83Z",
    stroke: "#121331",
    strokeWidth: 7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5e8c2c32993ee7701f058c52f2470260.svg";
export { ForwardRef as ReactComponent };